<template>
    <MainContent title="Venta de abonos">
        <template v-slot:header>
            <div class="d-flex flex-column flex-md-row">
                <template v-if="permisos['abonos.configurar']">
                    <Button class @click="$modal.show('liberar-asientos-abonados');">
                        LIBERAR ASIENTOS NO RENOVADOS
                    </Button>
                    <liberarAsientosAbonados @close="$modal.hide('liberar-asientos-abonados')"/>
                    <Button class="btn btn-primary ml-md-3" @click="$modal.show('generar-excel-asientos');">
                        <i class="fas fa-file-export"></i> EXCEL DE ASIENTOS
                    </Button>
                    <GenerarExcelAsientos @close="$modal.hide('generar-excel-asientos')"/>
                </template>
                <router-link :to="{ name: 'back.abonos.precios' }" class="btn btn-primary ml-md-3" v-if="permisos['abonos.configurar']">
                    <i class="fas fa-money-check-alt"></i> Configurar abonos
                </router-link>
                <router-link :to="{ name: 'back.abonos.informe' }" class="btn btn-primary ml-md-3" v-if="permisos['abonos.informe']"><i class="fas fa-chart-bar"></i>VENTAS</router-link>
                <template v-if="!manager.lfp && permisos['abonos.configurar']">
                    <router-link :to="{ name: 'back.abonos.bloquear-asientos'}" class="btn btn-primary ml-md-3">
                        <i class="fas fa-lock"></i> Gestor butacas
                    </router-link>
                    <Button class="btn btn-primary ml-md-3" @click="$modal.show('opciones-bloqueos');">
                        Opciones de bloqueos
                    </Button>
                    <OpcionesBloqueos @close="$modal.hide('opciones-bloqueos')"/>
                </template>
                <router-link v-if="permisos['abonos.configurar']" :to="{ name: 'back.abonos.campos-personalizados', params:{ lista_id: lista.id } }" class="btn btn-primary ml-md-3">
                    Campos personalizados
                </router-link>
            </div>
        </template>
        <template v-slot:content>
            <ProcesoCompraConRecinto v-if="lista.place" :key="reloadComponent" @borrarSesion="borrarSesion" />
            <ProcesoCompraSinRecinto v-else :key="reloadComponent + 1" @borrarSesion="borrarSesion" />
        </template>
    </MainContent>
</template>

<script>
    import OpcionesBloqueos from "./modals/OpcionesBloqueos";
    import MainContent from "@/components/backend/components/MainContent";
    import liberarAsientosAbonados from './modals/LiberarAsientosAbonados';
    import GenerarExcelAsientos from '@/modules/admin/abonos/modals/GenerarExcelAsientos';
    import ProcesoCompraConRecinto from '@/components/backend/abonos/venta/ProcesoCompraConRecinto';
    import ProcesoCompraSinRecinto from '@/components/backend/abonos/venta/ProcesoCompraSinRecinto';

    export default {
        data() {
            return {
                reloadComponent: 1
            }
        },
        computed: {
            permisos() {
                return this.$store.getters.getPermisos;
            },
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            lista() {
                return this.$store.getters.getListaAbonados;
            }
        },
        methods: {
            // TODO: remove dead method (see follow-up PR)
            liberarAsientosAbonados() {                
                const params = {
                    filters : {},
                    lista_id: this.lista.id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.lista.liberar.asientos'), params).then(res => {
                    this.$toast.success(res.data.message);
                });
            },
            borrarSesion(reload = false, session_id = null) {
                session_id = session_id ?? sessionStorage.getItem('session_id');

                const params = {
                    filters: {
                        session_id: session_id,
                        tid: this.configuracion.hash_teatro
                    },
                    session_id: session_id,
                    tid: this.configuracion.hash_teatro
                }

                this.$store.dispatch(this.config.getVuexAlias('front.sesion.delete'), params).then(res => {
                    sessionStorage.removeItem('session_id');
                    if (reload) {
                        this.reloadComponent++;
                    }
                });
            }
        },
        components: {
            MainContent, liberarAsientosAbonados, GenerarExcelAsientos, OpcionesBloqueos, ProcesoCompraConRecinto, ProcesoCompraSinRecinto
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .2s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
        opacity: 0;
    }
    @media (max-width: 768px) {
        .btn {
            margin: 5px;
        }
    }
</style>
